import script from "./TasksCounter.vue?vue&type=script&setup=true&lang=ts"
export * from "./TasksCounter.vue?vue&type=script&setup=true&lang=ts"

import "./TasksCounter.vue?vue&type=style&index=0&id=3e8e829a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e8e829a"]])

export default __exports__